import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { useTranslation } from "@/translations";

import { MeasuresCausesFormValues } from "../hooks/useMeasuresCauses";

interface Props {
  formik: FormikProps<MeasuresCausesFormValues>;
  field: keyof MeasuresCausesFormValues;
  index: number;
  options: string[];
  label: string;
  isFirst: boolean;
  addDisabled?: boolean;
  onAdd: () => void;
  onDelete: () => void;
}

export const DebtRow = ({ formik, field, index, options, label, isFirst, addDisabled, onAdd, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={2} alignItems="flex-start">
      <Stack flex={1}>
        <FormikAutocomplete formik={formik} path={`${field}.${index}.value`} label={label} options={options} required />
      </Stack>

      {isFirst ? (
        <IconButton
          aria-label={t("clients.measuresCauses.addMeasure")}
          onClick={onAdd}
          size="medium"
          disabled={addDisabled}
        >
          <AddCircleRoundedIcon />
        </IconButton>
      ) : (
        <IconButton aria-label={t("clients.measuresCauses.deleteRow")} onClick={onDelete} size="medium">
          <DeleteIcon />
        </IconButton>
      )}
    </Stack>
  );
};
